import get from 'lodash/get';
// import isArray from 'lodash/isArray';
// import FILTERS_NAMES from 'aurora-utils/filtersNames';
import * as types from './constants';

const defaultState = {
  loading: false,
  error: null,
  dropDowns: {},
};

export default function filtersReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_FILTER_DATA:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_FILTER_DATA_SUCCESS:
      const { name, data } = action.payload;
      return {
        ...state,
        loading: false,
        dropDowns: { ...state.dropDowns, [name]: data },
      };
    case types.FETCH_FILTER_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case types.CLEAR_FILTER_DATA:
      return {
        ...state,
        dropDowns: { ...state.dropDowns, [action.payload.name]: [] },
      };

    case types.FETCH_FILTERS_DROPDOWNS:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_FILTERS_DROPDOWNS_SUCCESS:
      return {
        ...state,
        loading: false,
        dropDowns: get(action.payload, 'dropDowns', {}),
        error: get(action.payload, 'error', null),
      };

    default:
      return state;
  }
}
